import { render } from "./LaunchpadView.vue?vue&type=template&id=cab6325a&scoped=true"
import script from "./LaunchpadView.vue?vue&type=script&lang=js"
export * from "./LaunchpadView.vue?vue&type=script&lang=js"

import "./LaunchpadView.vue?vue&type=style&index=0&id=cab6325a&scoped=true&lang=css"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cab6325a"]])

export default __exports__